"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useActivityFeedFiltersState = void 0;
const react_1 = require("react");
const useActivityFeedFiltersState = () => {
    const [selectedFilters, setselectedFilters] = (0, react_1.useState)({});
    const selectFilters = (filterKey) => {
        if (filterKey) {
            setselectedFilters({
                ...selectedFilters,
                [filterKey]: selectedFilters?.[filterKey] ? !selectedFilters[filterKey] : true,
            });
        }
    };
    return { selectedFilters, selectFilters };
};
exports.useActivityFeedFiltersState = useActivityFeedFiltersState;
//# sourceMappingURL=useActivityFeedFiltersState.js.map